const taxIdValidator = (input: string | null | undefined): boolean => {
  if (typeof input !== 'string') return false;
  if (input === '') return true;
  if (input.includes('_')) return false;
  return /^.{9}$/.test(input);
};

export default taxIdValidator;
